import { Track } from "./types/track";

const track: Track = {
    gamePlay: {
        lapCount: 5,
        checkpointsOrder: "normal",
        speed: 1,
    },
    theme: {
        sky: "night",
        roadHeight: 0.4,
        lensFlareOpacity: 1,
        particlesOpacity: 1,
        isRoadDoubleSided: true,
        roadShininess: 200,
    },
    styles: {
        red: {
            roadCenterColor: 0xf01860,
            roadEdgeColor: 0xff70a0,
            stripsWidth: [120, 40, 40],
            glassColor: 0xeeccdd,
        },
        blue: {
            roadCenterColor: 0x2080d0,
            roadEdgeColor: 0x80c0ff,
            stripsWidth: [120, 40, 40],
            glassColor: 0xccddee,
        },
    },
    segments: [
        {
            style: "blue",
            width: 1,
            vertices: [
                [0, 0, 0, 0],
                [7, 0, 0, 0],
                [9, 0, -2, -90],
                [9, 0, -3, -90],
                [9, 0.5, -5, -90],
            ],
        },
        {
            style: "red",
            width: 1,
            vertices: [
                [9, 0, -5.5, -90],
                [9, 0, -6, -90],
                [6, 0, -8, -180],
                [5, 0, -8, -180],
                [3.5, 0, -8.5, -135],
                [2, 0, -9, -180],
                [1, 0, -9, -180],
                [0, 0, -8.5, -225],
                [-1.5, 0, -8, -180],
                [-3, 0, -8, 180],
                [-8, 0, 0, 90],
                [-8, 0.5, 2.5, 90],
            ],
        },
        {
            style: "blue",
            width: 1,
            vertices: [
                [-8, 0, 3, 90],
                [-8, 0, 4, 90],
                [-4, 0, 8, 0],
                [-1, 0.75, 8, 0],
            ],
        },
        {
            style: "red",
            width: 1,
            vertices: [
                [0, 0, 8, 0],
                [6, 0, 8, 0],
                [8, 0.5, 6, -90],
                [8, 1, 2, -90],
                [6, 1.5, 0, -180],
                [4, 2, 0, -180],
                [2, 2.6, 0, -180],
            ],
        },
        {
            style: "red",
            width: 1,
            vertices: [
                [1, 2, 0, -180],
                [-2, 2, 0, -180],
                [-4, 2.6, 0, -180],
            ],
        },
        {
            style: "blue",
            width: 1,
            vertices: [
                [-5, 2, 0, -180],
                [-10, 2, 0, -180],
                [-12, 2, -2, -90],
                [-15, 1.5, -4, -180],
                [-18, 1, -2, -270],
                [-18, 0.5, 0, -270],
                [-18, 0, 2, 90],
                [-15, -0.5, 4, 0],
                [-12, -1, 2, -90],
                [-9, -1.5, 0, 0],
                [-4.5, -1, 0, 0],
                [0, 0, 0, 0],
            ],
        },
    ],
    environment: [],
    startingPoint: [
        [0, 0, 0, 0],
        [1, 1],
    ],
    checkpoints: [
        [[7, 0, 0, 0], [1, 1], true],
        [[7, 0, 0, 0], [1, 1], true],
        [[7, 0, 0, 0], [1, 1], true],
        [[7, 0, 0, 0], [1, 1], true],
    ],
};

export default track;
